import ENDPOINTS from "@app/constants/endpoints"
import { fetchWithValidation } from "@app/helpers/fetchWithValidation"
import { useQuery } from "@tanstack/react-query"
import { type Headers, HeadersSchema } from "../models/headers"

export const useHeaders = () => {
  return useQuery<Headers, Error>({
    queryKey: ["headers"],
    queryFn: () => fetchWithValidation(ENDPOINTS.HEADERS, HeadersSchema),
    staleTime: 1000 * 60 * 10, // 10 minute
  })
}
